<template>
    <div class="d-calendar__graph" v-if="cells.length">
        <calendar-cell :cell="cell" v-for="cell in cells" :key="cell.start_at.format('YYYY-MM-DD HH:mm')"></calendar-cell>
    </div>
</template>

<script>
	import {mapState, mapGetters} from 'vuex';
	import CalendarCell from "./CalendarCell.vue";

    export default {
		components: {CalendarCell},
		name: 'CalendarCells',
		computed: {
			...mapState([
				'cells',
			]),
		},
    }
</script>

